<template>
  <a href="#" @click.prevent="twitterLink(url, {title})" class="btn-share">
    <img src="/img/twitter-logo.svg">
  </a>
</template>

<script>
import objectToGetParams from '../../utils/objectToGetParams'
export default {
  name: 'twitter',
  methods: {
    twitterLink (url, { title }) {
      this.$emit('shared')
      window.open(
        'https://www.twitter.com/share' +
            objectToGetParams({
              url: url,
              text: title
            }),
        '__blank'
      )
    }
  },
  components: {},
  computed: {
      baseUrl () {
          return process.env.BASE_URL
      }
  },
  props: {
    url: {
      required: true,
      type: String
    },
    title: {
      required: false,
      type: String
    },
    scale: {
      required: false,
      type: String
    }
  }
}
</script>
